module.exports = __webpack_public_path__ + "static/media/sass.d615356c.svg";